"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const Switch_1 = require("../Switch/Switch");
const MockToggle_1 = require("./MockToggle");
const bem_helper_1 = require("../../helpers/bem-helper");
const backwardCompatibilityForProperties_1 = require("../../helpers/backwardCompatibilityForProperties");
const ToggleConstants_1 = require("./ToggleConstants");
require("./Toggle.scss");
const bemHelper = (0, bem_helper_1.BEMClass)(ToggleConstants_1.BASE_TOGGLE_CLASS_NAME);
const Toggle = ({ id, 
// Backward compatibility for props naming
componentClassName, className, isDefaultSelected = true, isSelected, onChange = noop_1.default, value, name, disabled, 
// Backward compatibility for props naming
isDisabled, ariaLabel, ariaControls, areLabelsHidden = false, onOverrideText = "On", offOverrideText = "Off" }) => {
    const overrideClassName = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([className, componentClassName]);
    const overrideDisabled = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([disabled, isDisabled], false);
    const wrapperClassName = (0, classnames_1.default)(bemHelper({ element: "wrapper" }), {
        [bemHelper({ element: "wrapper", state: "disabled" })]: overrideDisabled
    });
    const inputClassName = bemHelper({ element: "input" });
    return ((0, jsx_runtime_1.jsx)(Switch_1.Switch, Object.assign({ defaultChecked: isDefaultSelected, checked: isSelected, id: id, wrapperClassName: wrapperClassName, onChange: onChange, value: value, name: name, disabled: overrideDisabled, ariaLabel: ariaLabel, ariaControls: ariaControls, inputClassName: inputClassName }, { children: (0, jsx_runtime_1.jsx)(MockToggle_1.MockToggle, { areLabelsHidden: areLabelsHidden, offOverrideText: offOverrideText, className: overrideClassName, onOverrideText: onOverrideText }) })));
};
exports.default = Toggle;
